type FastApiDetailItem = { loc?: (string | number)[]; msg?: string };

export function parseFastApiValidationMessage(detail: unknown): string {
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((item: FastApiDetailItem) => item.msg || JSON.stringify(item))
      .filter(Boolean)
      .join(' ');
  }
  return 'Request could not be validated.';
}
